// extracted by mini-css-extract-plugin
module.exports = {"container":"_6be44ee","colorSelect":"_126e8bbc","swatch":"_7ac0e633","selected":"_8e81360"};